import {
  FormData as FormDataGenerated,
  FormData,
  ObalMaterialuFormDataApi,
} from 'evidencna-aplikacia-frontend-ts-axios';
import Uuid from '../../../model/Uuid';
import { ClientResponse } from '../../../model/ClientResponse';
import apiConfiguration from '../../configuration/apiConfiguration';
import { evidenciaPrefixPath } from '../../configuration/apiConfigurationConstants';
import { mapStadium } from '../../../model/legislativnyMaterial/StadiumMaterialu';

const client = new ObalMaterialuFormDataApi(apiConfiguration(evidenciaPrefixPath));

function map(formDataResponse: FormDataGenerated): FormData {
  return {
    formData: formDataResponse.formData ? JSON.parse(formDataResponse.formData) : null,
    stadium: formDataResponse.stadium ? mapStadium(formDataResponse.stadium) : null,
  };
}

// eslint-disable-next-line import/prefer-default-export
export const getObalMaterialuDetail = async (
  legMaterialUuid: Uuid,
  sprievodnyDokumentUuid: string,
  headers?: object,
): Promise<ClientResponse<FormData>> => {
  const {
    data,
    status,
  } = await client.getLatestFormData(legMaterialUuid, sprievodnyDokumentUuid, headers);

  return {
    data: data ? map(data) : null,
    responseCode: status,
  };
};
